import { ADD_ON_MODULES, ALWAYS_ON_MODULES, MODULE_CATALOGUE, addOnProblem, type AddOnModule } from '@his/shared';

interface PlanModules {
  id: string;
  moduleFlags: string[];
}

export interface AddOnState {
  code: AddOnModule;
  name: string;
  description: string;
  on: boolean;
  problem: string | null;
}

export function modulesOfChosen(plans: readonly PlanModules[] | undefined, chosenIds: readonly string[]): string[] {
  const held = new Set<string>(ALWAYS_ON_MODULES);
  for (const plan of plans ?? []) if (chosenIds.includes(plan.id)) for (const code of plan.moduleFlags) held.add(code);
  return [...held];
}

export function addOnStates(plans: readonly PlanModules[] | undefined, chosenIds: readonly string[], wanted: readonly AddOnModule[]): AddOnState[] {
  const held = modulesOfChosen(plans, chosenIds);
  return ADD_ON_MODULES.map((code) => {
    const descriptor = MODULE_CATALOGUE.find((module) => module.code === code);
    const problem = addOnProblem(code, held);
    return { code, name: descriptor?.name ?? code, description: descriptor?.description ?? '', on: problem === null && wanted.includes(code), problem };
  });
}

export function usableAddOns(plans: readonly PlanModules[] | undefined, chosenIds: readonly string[], wanted: readonly AddOnModule[]): AddOnModule[] {
  return addOnStates(plans, chosenIds, wanted)
    .filter((state) => state.on)
    .map((state) => state.code);
}
